<template>
  <div class="animation-container">
    <sprite-animation v-if="activeName != 'line' && activeName != 'video'"></sprite-animation>
    <line-animation v-if="activeName == 'line'"></line-animation>
    <video-animation v-if="activeName == 'video'"></video-animation>
  </div>
</template>
<script>
import SpriteAnimation from "./animation/sprite-animation.vue";
import LineAnimation from "./animation/line-animation.vue";
import VideoAnimation from './animation/video-animation.vue'
export default {
  components: {
    SpriteAnimation,
    LineAnimation,
    VideoAnimation
  },
  data() {
    return {
      activeName: "",
    };
  },
  created() {
    this.topo = this.$Core.getProvider("TechnologyTopo");
    this.init();
  },
  methods: {
    init() {
      if (this.topo.store && this.topo.store.active.length == 1) {
        this.active = this.topo.store.active[0];
      }
      if (!this.active) return;
      let name = this.active.name;

      this.activeName = name;
    },
  },
};
</script>
<style lang="scss" scoped>
</style>